module.exports = __webpack_public_path__ + "static/media/logo.2f0cb7fe.svg";